import axios from "axios";
import { ReduxStore } from "../../index";
import { GetStorage } from "../../Utils/Storage";
import { Notification } from "../../Utils/Notification";

export function api() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 120000,
    headers: {
      "Content-Type": "application/json",
      "X-Language": "EN",
    },
  });

  api.interceptors.request.use(
    function (config) {
      const token = GetStorage("optime_token");
      config.headers.Authorization = `Bearer ${token}` || "";
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  api.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error?.response?.status === 401) {
        const { dispatch } = ReduxStore;
        dispatch({ type: "USER_MUST_LOGIN", state: true });
      }
      if (error?.response?.status === 403) {
        Notification.pushNotif("Access Denied", "error");
      }
      //catches if the session ended!
      return Promise.reject(error);
    }
  );

  return api;
}

export function umsApi() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_UMS_URL,
    timeout: 120000,
    headers: {
      "Content-Type": "application/json",
        "X-Language": "EN",
    },
  });

  api.interceptors.request.use(
    function (config) {
      const token = GetStorage("optime_token");
      config.headers.Authorization = `Bearer ${token}` || "";
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  api.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error?.response?.status === 401) {
        const { dispatch } = ReduxStore;
        dispatch({ type: "USER_MUST_LOGIN", state: true });
      }
      if (error?.response?.status === 403) {
        Notification.pushNotif("Access Denied", "error");
      }
      //catches if the session ended!
      return Promise.reject(error);
    }
  );

  return api;
}
export function newApi() {
  const api = axios.create({
    baseURL: "http://95.38.60.148:5000",
    timeout: 120000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  api.interceptors.request.use(
    function (config) {
      const token = GetStorage("optime_token");
      config.headers.Authorization = `Bearer ${token}` || "";
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  api.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error?.response?.status === 401) {
        const { dispatch } = ReduxStore;
        dispatch({ type: "USER_MUST_LOGIN", state: true });
      }
      if (error?.response?.status === 403) {
        Notification.pushNotif("Access Denied", "error");
      }
      //catches if the session ended!
      return Promise.reject(error);
    }
  );

  return api;
}
